<template>
    <div class="land-list">
        <div class="land-item-info">
            <div class="item-info" v-for="(item, key, index) in landList" :key="key">
                <CompareItem
                    :item="item"
                    :name="keys[key] ? keys[key].str : ''"
                    :unit="keys[key] ? keys[key].unit : ''"
                    :decimal="keys[key] ? keys[key].decimal : 2"
                    :index="index"
                    :itemBgs="[6, 7, 8]"
                    :noshadow="false"
                />
            </div>
        </div>

        <div class="land-chart-box">
            <p class="u-agg-aii-ct">土地类型占比</p>
            <div class="land-chart">
                <PieChart
                    :data="landChartList"
                    :pieColors="['#447FF8', '#7FCD49']"
                />
            </div>
            <!-- <Pies
                :title="['土地类型','占比']"
                :color="color"
                :data="landChartList"
                yCenter
            /> -->
        </div>
    </div>
</template>

<script setup>
import CompareItem from '@/components/compareItem'
import Pies from '@/components/charts/chartsPie'
import { onMounted, reactive } from "vue";
import PieChart from '@/components/charts/nChartsPie.vue'



// 土地圆环颜色
const color = reactive(['#7FCD49', '#447FF8'])

const props = defineProps({
    landChartList: {
        type: Array,
        default: []
    },
    landList: {
        type: Object,
        default: {}
    },
    keys: {
        type: Object,
        default: {}
    }
})

</script>

<style scoped lang="less">
.land-list {
    width: 100%;
    margin-top: 20px;
    display: flex;
    justify-content: space-between;

    .land-item-info {
        width: 60%;
        height: 296px;
        background-color: #fff;
        display: flex;
        justify-content: space-between;
        padding: 20px;
        box-sizing: border-box;
        box-shadow: -4px 4px 23px 1px rgba(75, 173, 255, 0.1);
        border-radius: 10px;
    }

    .item-info {
        width: 32%;
        height: 257px;
        flex-shrink: 0;
    }

    .land-chart-box {
        width: calc(40% - 20px);
        padding: 20px 24px;
        box-sizing: border-box;
        height: 296px;
        background: #FFFFFF;
        display: flex;
        flex-direction: column;
        box-shadow: -4px 4px 23px 1px rgba(75, 173, 255, 0.1);
        border-radius: 10px;

        .land-chart {
            height: 100%;
            width: 100%;
        }
    }
}
</style>